export const formattingBalancePoints = (balancePoints: string) => {
	const formattedBalancePoints = new Intl.NumberFormat('en-US', {
		style: 'decimal',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(parseFloat(balancePoints));

	return formattedBalancePoints;
};
